module.exports = __webpack_public_path__ + "media/videos/home/hero-mobile-cf3d70bb4ca6e4b7ec23e58555dd1777.mp4";